type Values = Record<string, string | number | Array<string | number>>;

export type ResumeTheme = {
  useCustomProperties: boolean;
  useBodyStyles: boolean;
  baseSize: number | null | undefined;
  print: {
    backgroundColor: string;
    paddingX: number;
    paddingY: number;
  };
  web: {
    backgroundColor: string;
    maxWidth: number;
    contentWidth: number;
    paddingX: [number, number];
    paddingY: [number, number];
  };
  breakpoints?: string[];
  fonts: Values;
  colors: Values;
  fontSizes: any;
  space: any;
  fontWeights: Record<string, number>;
  lineHeights: Record<string, number>;
  letterSpacings: Values;
  text: Record<string, Values>;
  links: Record<string, Record<string, any>>;
  headerContainer: Values;
  sectionContainer: Values;
  detailSectionItemContainer: Values;
  blockListSectionItemContainer: Values;
  leftColumn: Values;
  summaryList: Values;
  // Custom for themes
  leftBar?: Values;
  firstColumn?: Values;
};

export const DEFAULT_BASE_SIZE = 16;

const theme: ResumeTheme = {
  useCustomProperties: false,
  useBodyStyles: false,
  baseSize: DEFAULT_BASE_SIZE,
  print: {
    backgroundColor: '#fff',
    paddingX: 60,
    paddingY: 60,
  },
  web: {
    backgroundColor: '#fff',
    maxWidth: 1000,
    contentWidth: 800,
    paddingX: [24, 60],
    paddingY: [40, 60],
  },
  fonts: {
    body: '-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji',
    heading:
      '-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji',
  },
  colors: {
    primaryText: '#000',
  },
  // Set these as empty to override defaults, which screw with small
  // values like <Box mb={3} /> where its space[3] instead of 3px.
  fontSizes: [],
  space: [],
  fontWeights: {
    body: 300,
    heading: 600,
    bold: 600,
  },
  lineHeights: {
    body: 1.5,
    heading: 1,
  },
  letterSpacings: {
    body: 'normal',
    caps: '1.2px',
  },
  text: {
    // Base text styles. Inherited by everything else.
    heading: {
      fontFamily: 'heading',
      lineHeight: 'heading',
      fontWeight: 'heading',
      color: 'primaryText',
    },
    body: {
      fontFamily: 'body',
      lineHeight: 'body',
      fontWeight: 'body',
      color: 'primaryText',
    },
    // Resume text elements
    resumeHeading: {
      variant: 'text.heading',
    },
    sectionHeading: {
      variant: 'text.heading',
    },
    sectionItemHeading: {
      variant: 'text.heading',
    },
    paragraph: {
      variant: 'text.body',
    },
    listItem: {
      variant: 'text.body',
    },
    summaryListItem: {
      variant: 'text.listItem',
    },
  },
  links: {
    inherit: {
      color: 'inherit',
      textDecoration: 'inherit',
      ':hover': {
        opacity: 0.7,
      },
    },
  },
  headerContainer: {},
  sectionContainer: {},
  detailSectionItemContainer: {},
  blockListSectionItemContainer: {},
  leftColumn: {},
  summaryList: {},
};

export default theme;
